import {connect} from 'react-redux';
import C from "../../constants";
import Reset from "../ui/ResetTest";

const mapDispatchToProps = dispatch => {
    return {
        resetTest() {
            dispatch({
                type: C.RESET
            })
        }
    }
};

export default connect(null, mapDispatchToProps)(Reset)
